// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FindCredentialsPage.css - 아이디/비밀번호 찾기 페이지 전용 스타일 */

.fcp-find-credentials-page {
    min-height: 100vh;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.fcp-container {
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    width: 100%;
    overflow: hidden;
}

.fcp-header {
    background: linear-gradient(135deg, #E84100 0%, #ff6b35 100%);
    color: white;
    padding: 40px 30px;
    text-align: center;
}

.fcp-header h1 {
    margin: 0 0 10px 0;
    font-size: 2rem;
    font-weight: 700;
}

.fcp-header p {
    margin: 0;
    font-size: 1rem;
    opacity: 0.9;
    line-height: 1.5;
}

.fcp-tab-container {
    padding: 0;
}

.fcp-tabs {
    display: flex;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

.fcp-tab {
    flex: 1 1;
    padding: 16px 20px;
    background: none;
    border: none;
    font-size: 1rem;
    font-weight: 500;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
}

.fcp-tab:hover {
    background-color: #e9ecef;
    color: #495057;
}

.fcp-tab.active {
    background-color: white;
    color: #E84100;
    font-weight: 600;
}

.fcp-tab.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: #E84100;
}

.fcp-tab-content {
    padding: 40px 30px;
    min-height: 400px;
}

.fcp-find-id-form h3,
.fcp-reset-password-form h3 {
    margin: 0 0 10px 0;
    font-size: 1.5rem;
    font-weight: 600;
    color: #212529;
}

.fcp-form-description {
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 30px;
    font-size: 0.95rem;
}

.fcp-form-group {
    margin-bottom: 24px;
}

.fcp-form-group label {
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    font-size: 0.95rem;
}

.fcp-form-group input {
    width: 100%;
    padding: 14px 16px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    box-sizing: border-box;
}

.fcp-form-group input:focus {
    outline: none;
    border-color: #E84100;
    box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);
}

.fcp-form-group input:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
    cursor: not-allowed;
}

.fcp-field-help {
    display: block;
    margin-top: 6px;
    font-size: 0.85rem;
    color: #6c757d;
    font-style: italic;
}

.fcp-security-notice {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 20px;
    margin: 24px 0;
}

.fcp-security-notice h4 {
    color: #856404;
    margin: 0 0 12px 0;
    font-size: 1rem;
    font-weight: 600;
}

.fcp-security-notice ul {
    margin: 0;
    padding-left: 20px;
    color: #856404;
}

.fcp-security-notice li {
    margin-bottom: 6px;
    font-size: 0.9rem;
}

.fcp-submit-btn {
    width: 100%;
    padding: 16px 24px;
    background: linear-gradient(135deg, #E84100 0%, #ff6b35 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 20px;
}

.fcp-submit-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #d73502 0%, #e55a2b 100%);
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(232, 65, 0, 0.3);
}

.fcp-submit-btn:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.fcp-actions {
    padding: 20px 30px;
    background-color: #f8f9fa;
    text-align: center;
    border-top: 1px solid #dee2e6;
}

.fcp-back-btn {
    background: none;
    border: 2px solid #6c757d;
    color: #6c757d;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.fcp-back-btn:hover {
    background-color: #6c757d;
    color: white;
}

.fcp-help {
    padding: 30px;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    text-align: center;
}

.fcp-help h4 {
    color: #495057;
    margin: 0 0 15px 0;
    font-size: 1.2rem;
    font-weight: 600;
}

.fcp-help p {
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 20px;
}

.fcp-contact-info {
    background: white;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #dee2e6;
    text-align: left;
    max-width: 400px;
    margin: 0 auto;
}

.fcp-contact-info p {
    margin: 8px 0;
    font-size: 0.95rem;
    color: #495057;
}

.fcp-contact-info strong {
    color: #E84100;
    font-weight: 600;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
    .fcp-find-credentials-page {
        padding: 10px;
        align-items: flex-start;
        padding-top: 20px;
    }
    
    .fcp-container {
        max-width: 100%;
        border-radius: 12px;
    }
    
    .fcp-header {
        padding: 30px 20px;
    }
    
    .fcp-header h1 {
        font-size: 1.6rem;
    }
    
    .fcp-tab-content {
        padding: 30px 20px;
        min-height: 350px;
    }
    
    .fcp-tab {
        padding: 14px 16px;
        font-size: 0.95rem;
    }
    
    .fcp-actions,
    .fcp-help {
        padding: 20px;
    }
    
    .fcp-contact-info {
        padding: 16px;
    }
}

@media (max-width: 480px) {
    .fcp-header {
        padding: 25px 15px;
    }
    
    .fcp-header h1 {
        font-size: 1.4rem;
    }
    
    .fcp-header p {
        font-size: 0.9rem;
    }
    
    .fcp-tab-content {
        padding: 25px 15px;
    }
    
    .fcp-form-group input {
        padding: 12px 14px;
    }
    
    .fcp-submit-btn {
        padding: 14px 20px;
        font-size: 1rem;
    }
    
    .fcp-actions,
    .fcp-help {
        padding: 15px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/FindCredentialsPage.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yGAAyG;AAC7G;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,wDAAwD;IACxD,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;AACJ","sourcesContent":["/* FindCredentialsPage.css - 아이디/비밀번호 찾기 페이지 전용 스타일 */\n\n.fcp-find-credentials-page {\n    min-height: 100vh;\n    background: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n.fcp-container {\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    max-width: 600px;\n    width: 100%;\n    overflow: hidden;\n}\n\n.fcp-header {\n    background: linear-gradient(135deg, #E84100 0%, #ff6b35 100%);\n    color: white;\n    padding: 40px 30px;\n    text-align: center;\n}\n\n.fcp-header h1 {\n    margin: 0 0 10px 0;\n    font-size: 2rem;\n    font-weight: 700;\n}\n\n.fcp-header p {\n    margin: 0;\n    font-size: 1rem;\n    opacity: 0.9;\n    line-height: 1.5;\n}\n\n.fcp-tab-container {\n    padding: 0;\n}\n\n.fcp-tabs {\n    display: flex;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.fcp-tab {\n    flex: 1;\n    padding: 16px 20px;\n    background: none;\n    border: none;\n    font-size: 1rem;\n    font-weight: 500;\n    color: #6c757d;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n.fcp-tab:hover {\n    background-color: #e9ecef;\n    color: #495057;\n}\n\n.fcp-tab.active {\n    background-color: white;\n    color: #E84100;\n    font-weight: 600;\n}\n\n.fcp-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background-color: #E84100;\n}\n\n.fcp-tab-content {\n    padding: 40px 30px;\n    min-height: 400px;\n}\n\n.fcp-find-id-form h3,\n.fcp-reset-password-form h3 {\n    margin: 0 0 10px 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #212529;\n}\n\n.fcp-form-description {\n    color: #6c757d;\n    line-height: 1.6;\n    margin-bottom: 30px;\n    font-size: 0.95rem;\n}\n\n.fcp-form-group {\n    margin-bottom: 24px;\n}\n\n.fcp-form-group label {\n    display: block;\n    font-weight: 600;\n    color: #495057;\n    margin-bottom: 8px;\n    font-size: 0.95rem;\n}\n\n.fcp-form-group input {\n    width: 100%;\n    padding: 14px 16px;\n    border: 2px solid #dee2e6;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n    box-sizing: border-box;\n}\n\n.fcp-form-group input:focus {\n    outline: none;\n    border-color: #E84100;\n    box-shadow: 0 0 0 3px rgba(232, 65, 0, 0.1);\n}\n\n.fcp-form-group input:disabled {\n    background-color: #f8f9fa;\n    color: #6c757d;\n    cursor: not-allowed;\n}\n\n.fcp-field-help {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.85rem;\n    color: #6c757d;\n    font-style: italic;\n}\n\n.fcp-security-notice {\n    background-color: #fff3cd;\n    border: 1px solid #ffeaa7;\n    border-radius: 8px;\n    padding: 20px;\n    margin: 24px 0;\n}\n\n.fcp-security-notice h4 {\n    color: #856404;\n    margin: 0 0 12px 0;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.fcp-security-notice ul {\n    margin: 0;\n    padding-left: 20px;\n    color: #856404;\n}\n\n.fcp-security-notice li {\n    margin-bottom: 6px;\n    font-size: 0.9rem;\n}\n\n.fcp-submit-btn {\n    width: 100%;\n    padding: 16px 24px;\n    background: linear-gradient(135deg, #E84100 0%, #ff6b35 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: 20px;\n}\n\n.fcp-submit-btn:hover:not(:disabled) {\n    background: linear-gradient(135deg, #d73502 0%, #e55a2b 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 8px 20px rgba(232, 65, 0, 0.3);\n}\n\n.fcp-submit-btn:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.fcp-actions {\n    padding: 20px 30px;\n    background-color: #f8f9fa;\n    text-align: center;\n    border-top: 1px solid #dee2e6;\n}\n\n.fcp-back-btn {\n    background: none;\n    border: 2px solid #6c757d;\n    color: #6c757d;\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.fcp-back-btn:hover {\n    background-color: #6c757d;\n    color: white;\n}\n\n.fcp-help {\n    padding: 30px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n    text-align: center;\n}\n\n.fcp-help h4 {\n    color: #495057;\n    margin: 0 0 15px 0;\n    font-size: 1.2rem;\n    font-weight: 600;\n}\n\n.fcp-help p {\n    color: #6c757d;\n    line-height: 1.6;\n    margin-bottom: 20px;\n}\n\n.fcp-contact-info {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    border: 1px solid #dee2e6;\n    text-align: left;\n    max-width: 400px;\n    margin: 0 auto;\n}\n\n.fcp-contact-info p {\n    margin: 8px 0;\n    font-size: 0.95rem;\n    color: #495057;\n}\n\n.fcp-contact-info strong {\n    color: #E84100;\n    font-weight: 600;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n    .fcp-find-credentials-page {\n        padding: 10px;\n        align-items: flex-start;\n        padding-top: 20px;\n    }\n    \n    .fcp-container {\n        max-width: 100%;\n        border-radius: 12px;\n    }\n    \n    .fcp-header {\n        padding: 30px 20px;\n    }\n    \n    .fcp-header h1 {\n        font-size: 1.6rem;\n    }\n    \n    .fcp-tab-content {\n        padding: 30px 20px;\n        min-height: 350px;\n    }\n    \n    .fcp-tab {\n        padding: 14px 16px;\n        font-size: 0.95rem;\n    }\n    \n    .fcp-actions,\n    .fcp-help {\n        padding: 20px;\n    }\n    \n    .fcp-contact-info {\n        padding: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .fcp-header {\n        padding: 25px 15px;\n    }\n    \n    .fcp-header h1 {\n        font-size: 1.4rem;\n    }\n    \n    .fcp-header p {\n        font-size: 0.9rem;\n    }\n    \n    .fcp-tab-content {\n        padding: 25px 15px;\n    }\n    \n    .fcp-form-group input {\n        padding: 12px 14px;\n    }\n    \n    .fcp-submit-btn {\n        padding: 14px 20px;\n        font-size: 1rem;\n    }\n    \n    .fcp-actions,\n    .fcp-help {\n        padding: 15px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
